module.exports = __webpack_public_path__ + "static/img/rollbook2.c88af20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sub/rollbook/rollbook2.png
// module id = ztzJ
// module chunks = 1